import { useSearchParams } from 'react-router-dom'
import { useTranslations } from 'use-intl'
import { PopupOutcomeCard, type PopupOutcomeCopy } from '@/components/PopupOutcomeCard'

type Outcome = 'returned' | 'cancelled' | 'error'

// Copy per specs/skattekonto/screens.md §2f, identical to apps/client's /tax/callback (the shared `tax.callback`
// catalog entries). None of it says the grant succeeded: the redirect only proves the user came back, and the
// consultant's originating tab decides the rest by asking Skatteverket which roles were actually signed for.

// The consultant twin of apps/client's /tax/callback (FIN-980). Reached only via
// skatteverket-capture-redirect's 302, which picks the app from the initiating_app recorded when
// the grant started. Public for the same reason as /bank/callback: Skatteverket's popup carries
// no session of its own, and this page does no work. Unrecognised outcomes read as "error".
export default function TaxCallback() {
  const [searchParams] = useSearchParams()
  const rawOutcome = searchParams.get('outcome')
  const outcome: Outcome = rawOutcome === 'returned' || rawOutcome === 'cancelled' ? rawOutcome : 'error'

  const t = useTranslations('tax.callback')
  const copy: Record<Outcome, PopupOutcomeCopy> = {
    returned: { title: t('returned.title'), message: t('returned.message'), variant: 'default' },
    cancelled: { title: t('cancelled.title'), message: t('cancelled.message'), variant: 'default' },
    error: { title: t('error.title'), message: t('error.message'), variant: 'destructive' },
  }

  return <PopupOutcomeCard copy={copy[outcome]} />
}
